import React from 'react';
import { Modal, Form, InputNumber, Alert, Button } from 'antd';

const ClearAggregationCacheModal = ({
  onSave,
  onCancel,
  form,
  clearCacheLoading,
}) => {
  const { getFieldDecorator } = form;

  const handleSave = e => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (err) return;
      onSave({
        params: {
          hubId: values.hubId,
        },
      });
    });
  };

  return (
    <Modal
      title="Clear CASE Report Aggregation Cache"
      visible
      width={520}
      footer={[
        <Button key="close" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="clear"
          type="danger"
          onClick={handleSave}
          loading={clearCacheLoading}
        >
          Clear cache
        </Button>,
      ]}
    >
      <Form layout="vertical">
        <Alert
          type="warning"
          showIcon
          message="This deletes all case_report_aggregation_jobs rows for the hub."
          description="Cached CASE report scores and download metadata for every date range on this hub will be removed. The next scores request or download will recompute from user_engagement_case_report."
          style={{ marginBottom: 16 }}
        />
        <Form.Item label="Hub ID">
          {getFieldDecorator('hubId', {
            rules: [
              { required: true, message: 'Hub ID is required' },
              {
                type: 'number',
                min: 1,
                message: 'Hub ID must be a positive number',
              },
            ],
          })(
            <InputNumber
              placeholder="e.g. 39"
              style={{ width: '100%' }}
              min={1}
              precision={0}
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Form.create({ name: 'clear_aggregation_cache_modal' })(
  ClearAggregationCacheModal
);
